import React from "react";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import { ToolbarWrapper, ToolbarFilter } from "src/components";

type AllProps = {
    users_list_length: number;
    filtered_length: number;
    handleAction: ActionHandlerFunction;
    filter_param?: string;
    refetchUsersShardStatuses: () => void;
};

// Description: This component is used to render the toolbar of the list of users in the data export get started page
function ToolbarComponent(props: AllProps) {
    const { users_list_length, filtered_length, filter_param, handleAction, refetchUsersShardStatuses } = props;

    return <ToolbarWrapper
        leftContent={<ToolbarFilter
            disabled={users_list_length === 0}
            filter_param={filter_param ?? ""}
            onChange={(value) => handleAction({ actionType: AdminUIActionTypes.SearchParam, params: value })}
            onClick={() => handleAction({ actionType: AdminUIActionTypes.SearchParam })} />}
        refreshAction={() => refetchUsersShardStatuses()}
        refreshTooltipContent="Refresh Users"
        isLoading={false}
        paginationInfo={filtered_length > 0 ? <span>{`${filtered_length} User${filtered_length > 1 ? "s" : ""}`}</span> : undefined}
    />;
}

export default React.memo(ToolbarComponent);
